export default __webpack_public_path__ + "static/media/Brow_3_C4.eca15476.svg";